import axios from 'axios';
import map from 'lodash/map';
import { assert } from '../../utils/assert';

import * as types from './mutation-types';
import { revalidate } from '../utils/hash';
import { getConfig } from '../utils/support';


/**
 * Displays the requested resource as a panel.
 *
 * This first creates an empty instance (or overwrites one in strict mode)
 * then sends off an AJAX request to update the data later.
 *
 * @param store
 * @param payload
 */
export const display = ({ commit, getters }, {
  key = '', id = -1, index = Number.MAX_SAFE_INTEGER,
}) => {
  if (id < 0) return;
  assert(Number.isInteger(index), 'Invalid index provided');

  const config = getConfig(key);
  assert(config, `No support for '${key}' found`);

  const { items } = getters;
  index = Math.min(items.length, index);

  // Check for existing data
  const { data = {} } = getters.fetch(key, id) || {};
  const cancelToken = axios.CancelToken.source();
  const panel = items[index] || {};
  const payload = {
    key,
    id,
    data,
    cancelToken,
    loading: true,
  };

  // Cancel loading panels before updating or just append a new one
  if (panel.key === undefined || panel.key !== key) {
    commit(types.ADD, { index, item: payload });
  } else {
    if (panel.cancelToken !== null) {
      panel.cancelToken.cancel();
    }

    commit(types.UPDATE, {
      uuid: panel.uuid,
      changes: payload,
    });
  }

  // Fetch data from server
  const { uuid } = items[index];

  axios(config.request(id), { cancelToken: cancelToken.token })
    .then(response => commit(types.UPDATE, {
      uuid,
      merge: true,
      changes: {
        loading: false,
        errors: null,
        data: response.data,
        showOptions: false,
        cancelToken: null,
      },
    }))
    .catch((errors) => {
      if (axios.isCancel(errors)) return;

      commit(types.UPDATE, {
        uuid,
        changes: {
          loading: false,
          cancelToken: null,
          errors,
        },
      });
    });
};

/**
 * Refreshes all items by comparing the hash with our internal list.
 * New items will be loaded from the server, while existing ones will be reused.
 *
 * @param store
 */
export const refresh = ({
  state, commit, getters, dispatch,
}) => {
  if (state.refreshing) {
    commit(types.REFRESH, false);
    return;
  }

  // Build new stack and fetch existing items if we can
  const stack = map(revalidate(), (entry) => {
    const cached = getters.fetch(entry.key, entry.id);
    return cached || entry;
  });

  // Either insert existing items or display new ones
  commit(types.REFRESH, () => {
    for (let i = 0; i < stack.length; i += 1) {
      const entry = stack[i];

      if (entry.uuid) {
        commit(types.INSERT, entry);
      } else {
        dispatch('display', { key: entry.key, id: entry.id, index: i });
      }
    }
  });
};



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/store/actions.js